<mat-icon *ngIf="filteredArtifacts" matTooltip="View Source Artifacts" class="link" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger" (click)="trigger.openMenu()"
  [class.text-success]="!colourOverride"
  [class.text-warning]="colourOverride === 'warning'"
  [class.text-info]="colourOverride === 'info'">grid_view</mat-icon>
<mat-menu #menu="matMenu" class="source-artifacts-panel">
  <ng-container *ngFor="let group of filteredArtifacts">
    <div class="w-100 text-center">
      <small [class.light]="!isDarkMode" [class.dark]="isDarkMode">{{ group.groupKey }}</small>
    </div>
    <div *ngFor="let artifact of group.artifacts" class="source-artifact-row copyable">
      <small class="company" [matTooltip]="artifact.companyCode ? 'Company ' + artifact.companyCode : ''">
        <a *ngIf="isSituUser && getCompanyId(artifact.companyCode) as companyId; else companyText" class="link"
          [routerLink]="['/admin/companies', companyId]">{{ artifact.companyCode }}</a>
        <ng-template #companyText>{{ artifact.companyCode }}</ng-template>
      </small>
      <button mat-menu-item class="name" [disabled]="!artifact.isClickable" [routerLink]="artifact.routes" [queryParams]="artifact.queryParams">
        <small>{{ artifact.displayText }} <span class="text-info">v{{ artifact?.version }}</span></small>
      </button>
      <span class="actions">
        <copy-value label="Key" [value]="artifact.fullKey"></copy-value>
      </span>
    </div>
  </ng-container>
</mat-menu>
